import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSaveSelectedFactsStatsAndQuotesArgs,
  BackendProject,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SaveSelectedFactsStatsAndQuotes(
    $projectId: ID!
    $selectedFactsStatsAndQuotes: [StatsFactsAndQuotesInput]
  ) {
    saveSelectedFactsStatsAndQuotes(
      projectId: $projectId
      selectedFactsStatsAndQuotes: $selectedFactsStatsAndQuotes
    ) {
      id
    }
  }
`;

type Variables = BackendMutationSaveSelectedFactsStatsAndQuotesArgs;
type Result = Pick<BackendProject, 'id'>;

export const updateSelectedStatsFactsAndQuotes = async (
  variables: Variables
): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
